export class StringService {
    containsStringInsensitive(needle, haystack) {
        return haystack.some(
            item => typeof item === "string" && item.toLowerCase() === needle.toLowerCase()
        );
    }

    isValidUrl(str) {
        try {
            const url = new URL(str.includes('://') ? str : `http://${str}`);
            return !!url.hostname && url.hostname.includes('.');
        } catch (_) {
            return false;
        }
    }

}